import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from '../query-schema';
import { Input } from '~/components/Input';
import { formatDate } from '~/utils/date';
import { ChangeEvent } from 'react';

const ACTIVE_VALUE = 'active';

function getLicenseYearOptions(): [string, string][] {
  const currentYear = new Date().getFullYear();
  const options: [string, string][] = [
    ['Visa alla', ''],
    ['Endast aktiva', ACTIVE_VALUE],
  ];
  for (let y = currentYear; y >= 2010; y--) {
    options.push([`${y}`, `${y}`]);
  }
  return options;
}

function deriveSelectValue(values: { valid_license_on?: string; license_year?: number }): string {
  if (values.license_year) return `${values.license_year}`;
  if (values.valid_license_on) return ACTIVE_VALUE;
  return '';
}

export function LifterListFilter() {
  const { register, setValues, values } = useFilterForm(querySchema.parse);

  function handleChange(event: ChangeEvent<{ value: string }>) {
    const selected = event.target.value;

    if (selected === '') {
      setValues({ valid_license_on: undefined, license_year: undefined });
    } else if (selected === ACTIVE_VALUE) {
      setValues({ valid_license_on: formatDate(new Date(), 'yyyy-mm-dd'), license_year: undefined });
    } else {
      setValues({ license_year: selected, valid_license_on: undefined });
    }
  }

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på namn..." />

      <Table.Filter>
        <Table.FilterSection label="Licens">
          <Input.Select
            options={getLicenseYearOptions()}
            onChange={handleChange}
            defaultValue={deriveSelectValue(values)}
          />
        </Table.FilterSection>
      </Table.Filter>
    </Table.Bar>
  );
}
